import React from 'react';
import {Field} from "formik";
import {Accordion, AccordionDetails, AccordionSummary, IconButton, Stack, TextField, Typography} from "@mui/material";
import {ChevronLeft, ChevronRight, ExpandMore, AccountBalance, CategoryOutlined, CalendarToday, Notes} from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";

function StageDetails({isSubmitting, submitform, values, setFieldValue, touched, errors, handleChange, categories, accounts}) {
  const previousDate = () => {
    const date = new Date(values.date);
    date.setDate(date.getDate() - 1);
    setFieldValue('date', date.toISOString().substr(0, 10));
  }
  const nextDate = () => {
    const date = new Date(values.date);
    date.setDate(date.getDate() + 1);
    setFieldValue('date', date.toISOString().substr(0, 10));
  }
  const categoryList = categories || [
    'Clothing & Footwear',
    'Food & Drink',
    'Gifts',
    'Groceries',
    'Health & Personal Care',
    'Home & Utilities',
    'Leisure',
    'Other',
    'Transport',
    'Travel',
  ];
  const accountList = accounts || [
    'Cash',
  ];

  return <div className="stage-details">
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="category-content"
        id="category-header"
        className="section-accordion-summary"
      >
        <CategoryOutlined />
        <Typography>Category</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div role="group" aria-labelledby="category-radio-group" className="category-radio-group">
          {categoryList.map((category) =>
            <label key={category}>
              <Field type="radio" name="category" value={category} />
              <span>{category}</span>
            </label>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="date-content"
        id="date-header"
        className="section-accordion-summary"
      >
        <CalendarToday />
        <Typography>Date</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="row" spacing={1} justifyContent="center">
          <IconButton aria-label="previous day" onClick={previousDate}>
            <ChevronLeft />
          </IconButton>
          <Field type="date" name="date" />
          <IconButton aria-label="next day" onClick={nextDate}>
            <ChevronRight />
          </IconButton>
        </Stack>
      </AccordionDetails>
    </Accordion>
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="account-content"
        id="account-header"
        className="section-accordion-summary"
      >
        <AccountBalance />
        <Typography>Account</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div role="group" aria-labelledby="account-radio-group" className="account-radio-group">
          {accountList.map((account) =>
            <label key={account}>
              <Field type="radio" name="account" value={account} />
              <span>{account}</span>
            </label>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="description-content"
        id="description-header"
        className="section-accordion-summary"
      >
        <Notes />
        <Typography>Description</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TextField
          fullWidth
          id="description"
          name="description"
          label="Name of vendor or description of expense"
          value={values.description}
          onChange={handleChange}
          error={touched.description && Boolean(errors.description)}
          helperText={touched.email && errors.description}
        />
      </AccordionDetails>
    </Accordion>

    <LoadingButton loading={isSubmitting} variant="contained" size="large" color="primary" onClick={submitform}>Save</LoadingButton>
  </div>;
}

export default StageDetails;